import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import completionPopper from '@/assets/learner/completion-popper.svg'
import { TestLayout } from '@/components/learner/test'
import { useLogout } from '@/hooks/useLogout'

/** 수학머리 테스트 완료 화면. 로그아웃 후에도 현재 완료 화면은 유지한다. */
export default function DiagnosticAiqComplete() {
  const { t } = useTranslation('learner')
  const didLogoutRef = useRef(false)
  const logout = useLogout({ redirect: false, allowCurrentPathAfterLogout: true })

  useEffect(() => {
    if (didLogoutRef.current) return
    didLogoutRef.current = true
    logout.mutate()
  }, [logout])

  return (
    <TestLayout variant="card">
      <div className="flex flex-col items-center gap-6">
        <div className="flex size-20 items-center justify-center rounded-full bg-lc-key-50">
          <img src={completionPopper} alt="" className="size-10" />
        </div>
        <div className="flex flex-col items-center gap-2">
          <h1 className="text-lc-v3-h1 font-bold text-lc-text-primary">
            {t('diagnostic.aiqComplete.title')}
          </h1>
        </div>
        <p className="whitespace-pre-line text-lc-v3-body-1 font-medium text-lc-text-secondary">
          {t('diagnostic.aiqComplete.body')}
        </p>
      </div>
    </TestLayout>
  )
}
